import {
  ITenantStorageOptionRepository,
  TenantStorageOption,
} from "../../../domain/tenant-storage-option";
import { Injectable } from "@angular/core";
import { HttpService } from "../../http/http";

@Injectable()
export class TenantStorageOptionRepository
  implements ITenantStorageOptionRepository
{
  constructor(private _httpService: HttpService) {}
  delete(optionToDelete: TenantStorageOption): Promise<void> {
    return this._httpService.delete(
      `MediaAssociation/TenantBucketOption/${optionToDelete.id}`,
    );
  }

  insertNew(
    id: string,
    displayName: string,
    bucketName: string,
    region: string,
    accessKey: string,
    secretKey: string,
    serviceUrl: string,
  ): Promise<void> {
    return this._httpService.post(`TenantBucketOption/New`, {
      Id: id,
      DisplayName: displayName,
      BucketName: bucketName,
      Region: region,
      AccessKey: accessKey,
      SecretKey: secretKey,
      ServiceUrl: serviceUrl,
    });
  }
}
